// ============================================================
// DXO Core — Access Rights
// Range: 1001–1099
// ============================================================

export const CORE_ACCESS_RIGHTS = {

  //#region SECURITY
  CORE_SECURITY_USERS:                                  1001,
  CORE_SECURITY_ROLES:                                  1002,
  CORE_SECURITY_AUDITLOGS:                              1003,
  //#endregion

  //#region TRANSACTIONS — ACCESS REQUESTS
  CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER:              1004,
  CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR:           1005,
  CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER:            1006,
  //#endregion

};